import { FeaturePermissionInterface } from './feature-permission.model';

export interface FeatureInterface {
  featureId: number;
  featureCode: string;
  featureName: string;
  description: string;
  isActive: boolean;
  permissions: FeaturePermissionInterface[];
}

export class Feature implements FeatureInterface {
  public featureId: number;
  public featureCode: string;
  public featureName: string;
  public description: string;
  public isActive: boolean;
  public permissions: FeaturePermissionInterface[];

  constructor({
    featureId = 0,
    featureCode = '',
    featureName = '',
    description = '',
    isActive = false,
    permissions = [],
  }: Partial<FeatureInterface>) {
    this.featureId = featureId;
    this.featureCode = featureCode;
    this.featureName = featureName;
    this.description = description;
    this.isActive = isActive;
    this.permissions = permissions;
  }
}
